import { defineChain } from 'viem';
import { createConfig, http } from 'wagmi';
import { injected } from 'wagmi/connectors';

export const genesisChain = defineChain({
  blockExplorers: {
    default: {
      name: import.meta.env.VITE_BLOCK_EXPLORERS_NAME,
      url: import.meta.env.VITE_BLOCK_EXPLORERS_URL
    }
  },
  id: Number(import.meta.env.VITE_CHAIN_ID),
  name: import.meta.env.VITE_CHAIN_NAME,
  nativeCurrency: {
    decimals: 18,
    name: import.meta.env.VITE_CHAIN_CURRENCY_NAME,
    symbol: import.meta.env.VITE_CHAIN_CURRENCY_SYMBOL
  },
  rpcUrls: {
    default: {
      http: [import.meta.env.VITE_RPC_URLS]
    }
  },
  testnet: true
});

export const config = createConfig({
  chains: [genesisChain],
  connectors: [injected()],
  transports: {
    [genesisChain.id]: http()
  }
});

declare module 'wagmi' {
  interface Register {
    config: typeof config;
  }
}
